import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const CourseIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="course icon">
      {/* <title>course icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1192 4.38462C17.3941 4.38462 18.4267 5.41749 18.4267 6.69116V14.2307C17.7646 13.6818 16.9145 13.3518 15.9872 13.3518H7.6741C7.56343 13.3518 7.47546 13.263 7.47546 13.1541V4.58236C7.47546 4.47344 7.56343 4.38462 7.6741 4.38462H16.1192ZM19.8113 17.1759V6.69116C19.8113 4.65252 18.1585 3 16.1192 3H7.6741C6.8005 3 6.09084 3.70692 6.09084 4.58236V6.27935L4.92859 6.26564C4.0477 6.25607 3.32733 6.96766 3.32733 7.84885V19.4167C3.32733 20.2913 4.03607 21 4.91059 21H15.9872C18.0993 21 19.8113 19.2881 19.8113 17.1759ZM6.09084 7.66407V13.1541C6.09084 14.0296 6.8005 14.7365 7.6741 14.7365H15.9872C17.3346 14.7365 18.4267 15.8285 18.4267 17.1759C18.4267 18.5234 17.3346 19.6154 15.9872 19.6154H4.91059C4.80075 19.6154 4.71195 19.5266 4.71195 19.4167V7.84885C4.71195 7.73861 4.80213 7.64913 4.91263 7.65017C4.91272 7.65017 4.91253 7.65017 4.91263 7.65017L6.09084 7.66407ZM16.3771 17.1888C16.3771 16.8065 16.0671 16.4965 15.6848 16.4965H6.95761C6.57527 16.4965 6.2653 16.8065 6.2653 17.1888C6.2653 17.5711 6.57527 17.8811 6.95761 17.8811H15.6848C16.0671 17.8811 16.3771 17.5711 16.3771 17.1888Z"
        fill={props.fill || "currentColor" || "#747981"}
      />
    </svg>
  );
};

export default CourseIcon;
